// // import { useState } from 'react';
// // import { Link } from 'react-router-dom';

// // export default function Header() {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);

// //   return (
// //     <header className="bg-white shadow-sm sticky top-0 z-50">
// //       <nav className="max-w-6xl mx-auto px-4">
// //         <div className="flex justify-between items-center h-16">
// //           <div className="text-2xl font-heading font-bold text-primary-base">Capital Offset</div>
          
// //           {/* Desktop Menu */}
// //           <div className="hidden md:flex space-x-8">
// //             <Link to="/" className={`text-gray-600 font-medium hover:text-primary-dark`}>Home</Link>
// //             <Link to="/services" className={`text-gray-600 font-medium hover:text-primary-dark`}>Services</Link>
// //             <Link to="/contact" className={`text-gray-600 font-medium hover:text-primary-dark`}>Contact Us</Link>

// //           </div>
          
// //           {/* Mobile Menu Button */}
// //           <button 
// //             className="md:hidden p-2"
// //             onClick={() => setIsMenuOpen(!isMenuOpen)}
// //           >
// //             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
// //             </svg>
// //           </button>
// //         </div>
        
// //         {/* Mobile Menu */}
// //         {isMenuOpen && (
// //           <div className="md:hidden absolute bg-white w-full left-0 px-4 pb-4 shadow-md">
// //             <Link to="/" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Home</Link>
// //             <Link to="/services" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Services</Link>
// //             <Link to="/contact" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Contact Us</Link>
// //           </div>
// //         )}
// //       </nav>
// //     </header>
// //   )
// // }

// import { useState } from 'react';
// import { Link } from 'react-router-dom';

// export default function Header() {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);

//   return (
//     <header className="bg-white shadow-sm sticky top-0 z-50">
//       <nav className="max-w-6xl mx-auto px-4">
//         <div className="flex justify-between items-center h-16">
//           <div className="text-2xl font-heading font-bold text-primary-base">Capital Offset</div>
          
//           {/* Desktop Menu */}
//           <div className="hidden md:flex space-x-8 relative">
//             <Link to="/" className={`text-gray-600 font-medium hover:text-primary-dark`}>Home</Link>

//             {/* Services Dropdown */}
//             <div
//               className="relative"
//               onMouseEnter={() => setIsServicesDropdownOpen(true)}
//               onMouseLeave={() => setIsServicesDropdownOpen(false)}
//             >
//               <Link
//                 to="/services"
//                 className={`text-gray-600 font-medium hover:text-primary-dark`}
//               >
//                 Services
//               </Link>
//               {isServicesDropdownOpen && (
//                 <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-lg">
//                   <Link
//                     to="/service1"
//                     className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
//                   >
//                     Service 1
//                   </Link>
//                   <Link
//                     to="/service2"
//                     className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
//                   >
//                     Service 2
//                   </Link>
//                   <Link
//                     to="/service3"
//                     className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
//                   >
//                     Service 3
//                   </Link>
//                 </div>
//               )}
//             </div>

//             <Link to="/contact" className={`text-gray-600 font-medium hover:text-primary-dark`}>Contact Us</Link>
//           </div>
          
//           {/* Mobile Menu Button */}
//           <button 
//             className="md:hidden p-2"
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//           >
//             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//             </svg>
//           </button>
//         </div>
        
//         {/* Mobile Menu */}
//         {isMenuOpen && (
//           <div className="md:hidden absolute bg-white w-full left-0 px-4 pb-4 shadow-md">
//             <Link to="/" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Home</Link>
//             <div className="relative">
//               <Link to="/services" className={`block py-2 text-gray-600 hover:text-primary-dark`}>
//                 Services
//               </Link>
//               <div className="absolute left-0 w-full mt-2 bg-white shadow-lg rounded-lg">
//                 <Link
//                   to="/service1"
//                   className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
//                 >
//                   Service 1
//                 </Link>
//                 <Link
//                   to="/service2"
//                   className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
//                 >
//                   Service 2
//                 </Link>
//                 <Link
//                   to="/service3"
//                   className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
//                 >
//                   Service 3
//                 </Link>
//               </div>
//             </div>
//             <Link to="/contact" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Contact Us</Link>
//           </div>
//         )}
//       </nav>
//     </header>
//   );
// }
import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Untitled design (3).svg'
export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center ">
          
        <div className="flex items-center space-x-2">
        <img 
          src={logo} 
          alt="Capital Offset Logo" 
          className="h-12 w-auto" // Adjust the size as needed
        />
        <div className="text-2xl font-heading font-bold text-primary-base">Capital Offset</div>
      </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 relative ">
            <Link to="/" className={`text-gray-600 font-medium hover:text-primary-dark py-5`}>Home</Link>

            {/* Services Dropdown */}
            <div
              className="relative py-5"
              onMouseEnter={() => setIsServicesDropdownOpen(true)}
              onMouseLeave={() => setIsServicesDropdownOpen(false)}
            >
              <Link
                to="/services"
                className={`text-gray-600 font-medium hover:text-primary-dark relative`}
              >
                Services
              </Link>
              {isServicesDropdownOpen && (
                <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-lg overflow-hidden transition-all duration-300">
                  <Link
                    to="/services/pre-press"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Pre Press
                  </Link>
                  <Link
                    to="/services/digital-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Digital Printing
                  </Link>
                  <Link
                    to="/services/offset-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Offset Printing
                  </Link>
                  <Link
                    to="/services/post-press"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Post Press
                  </Link>
                  <Link
                    to="/services/packaging"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Packaging
                  </Link>
                  <Link
                    to="/services/card-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Card Printing
                  </Link>
                  <Link
                    to="/services/brochure-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Brochure Printing
                  </Link>
                  <Link
                    to="/services/catalog-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Catalog Printing
                  </Link>
                  <Link
                    to="/services/book-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Book Printing
                  </Link>
                  <Link
                    to="/services/box-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Box Printing
                  </Link>
                </div>
              )}
            </div>

            <Link to="/contact" className={`text-gray-600 font-medium hover:text-primary-dark py-5`}>Contact Us</Link>
          </div>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute bg-white w-full left-0 px-4 pb-4 shadow-md">
            <Link to="/" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Home</Link>
            <div className="relative">
              <Link to="/services" className={`block py-2 text-gray-600 hover:text-primary-dark`}>
                Services
              </Link>
              <div className="absolute left-0 w-full mt-2 bg-white shadow-lg rounded-lg">
              <Link
                    to="/services/pre-press"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Pre Press
                  </Link>
                  <Link
                    to="/services/digital-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Digital Printing
                  </Link>
                  <Link
                    to="/services/offset-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Offset Printing
                  </Link>
                  <Link
                    to="/services/post-press"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Post Press
                  </Link>
                  <Link
                    to="/services/packaging"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Packaging
                  </Link>
                  <Link
                    to="/services/card-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Card Printing
                  </Link>
                  <Link
                    to="/services/brochure-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Brochure Printing
                  </Link>
                  <Link
                    to="/services/catalog-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Catalog Printing
                  </Link>
                  <Link
                    to="/services/book-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Book Printing
                  </Link>
                  <Link
                    to="/services/box-printing"
                    className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
                  >
                    Box Printing
                  </Link>
              </div>
            </div>
            <Link to="/contact" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Contact Us</Link>
          </div>
        )}
      </nav>
    </header>
  );
}



